export const SWITCH_BACK = '/portal/impersonate/switch_back.do?origin=redesign';
export const SDP_DEMO_DO = '/portal/switchUserDemo.do?userid=sdp.demo&code=SWITCH-TO-DEMO&origin=redesign';
export const SDP_SIGNOFF_DO = '/portal/signoff.do#';
export const SDP_DASHBOARD_DO = '/portal/dashboard.do#';
export const MAIN_REDESIGN_DASHBOARD = '/portal/dashboard-app.do#/sdp-dashboard';
export const DASHBOARD_NLP_SEARCH = '/portal/dashboard-app.do#/sdp-dashboard/nlp-search';
export const IAM_APP_DO = '/portal/iam-app.do#';
export const ORDERS_APP_DO = '/portal/orders-app.do#';
export const REQUESTS_APP_DO = '/portal/requests-app.do#';
export const ANALYTICS_APP_DO = '/portal/analytics-app.do#';
export const THREED_MAPPER_DO = '/portal/3d-mapper-ui.do';
export const SPACE_PLANNING_DO = '/portal/space-planning.do';
export const ASSET_MANAGER_DO = '/portal/assetmanager-ui.do';
export const SUSTAINABILITY_DO = '/portal/sustainability.do';
export const VIDEO_MANAGEMENT_DO = '/portal/video-management.do';
export const SERVICE_DESK_APP_DO = '/portal/service-desk.do?code={{CODE}}#';
export const ACCOUNT_APP_DO = '/portal/account-app.do#';
export const ROSTER_UI_DO_URL = '/portal/roster-ui.do?code={{CODE}}#';
export const MY_PROFILE = '/portal/iam-app.do?code=IAM_APP#/iam/my-profile/';
export const MY_COMPANY = '/portal/iam-app.do?code=IAM_APP#/iam/my-company/';
export const CALENDAR_UI_DO_URL = 'portal/calendar-ui.do?code={{CODE}}#';
export const CONNECTIVITY_SERVICES_APP_ROUTE = `/portal/connectivity-service-app.do?code=CONNECTIVITY_APP#`;
export const ONLINE_ORDERING_UI_DO = '/portal/module3-onlineOrdering-ui.do?code={{CODE}}#';
export const NOTIFICATION_CENTER_DO_URL = '/portal/notification-center.do?code={{CODE}}#';
export const CONNECTIVITY_MARKETPLACE_DO_URL = '/portal/connectivity-marketplace.do?code={{CODE}}';
export const SENSORS_ANALYTICS_DATA_HALL_DO_URL = '/portal/sensors-analytics-data-hall.do?code={{CODE}}#';
export const POWER_ANALYTICS_DO_URL = `/portal/power-analytics.do?code={{CODE}}#`;
export const INFRASTRUCTURE_DEVICES_DO_URL = '/portal/infrastructure-devices-ui.do?code={{CODE}}#';
export const INVOICES_DO_URL = '/portal/invoices.do?code={{CODE}}#';
export const LEGACY_URL = {
    FOURTH_WALL_UI_DO: '/portal/fourth-wall-ui.do?pagefragment={{PAGEFRAGMENT}}',
};
export const DEFAULT_TEXTAREA_CHARACTER_COUNT_MAX = 1000;
export const DEFAULT_ITEMS_PER_PAGE = 25;
export const DEFAULT_SORT_COLUMN_NAME = 'created';
export const DEFAULT_ITEMS_PER_PAGE_ARRAY = [5, 10, 25, 50, 100, 200];
export const MIN_SEARCH_LENGTH = 3;
export const AUTO_COMPLETE_FIELDS = [
    'companies',
    'clientIds',
    'client',
    'createdBy',
    'updatedBy',
    'readerNames',
    'aliases',
    'id',
    'parentId',
    'badgeReaderCompany',
];
export const SEARCH_PLACEHOLDER = 'Search';
export const ONE_MB_IN_BYTES = 1048576;
export const ALLOWED_FILE_TYPE = '.PDF,.PNG,.JPG,.XLSX';
export const API_SERVICE_HEADER_CONTENT_TYPES = {
    multipart: 'multipart/form-data',
};
export var TIME_MERIDIAN;
(function (TIME_MERIDIAN) {
    TIME_MERIDIAN["PM"] = "PM";
    TIME_MERIDIAN["AM"] = "AM";
})(TIME_MERIDIAN || (TIME_MERIDIAN = {}));
export var DATE_FORMATS;
(function (DATE_FORMATS) {
    // Valid
    DATE_FORMATS["M_D_YYYY_H_MM_AM_PM"] = "M-D-YYYY H:MM PM";
    DATE_FORMATS["M_D_YYYY_H_MM_AM_PM_TIMEZONE"] = "M-D-YYYY H:MM PM TIMEZONE";
    DATE_FORMATS["M_D_YYYY_HH_MM_SS_AM_PM"] = "M-D-YYYY HH:MM:SS PM";
    DATE_FORMATS["M_D_YYYY_HH_MM"] = "M-D-YYYY HH:MM";
    DATE_FORMATS["M_DD_YYYY"] = "M-DD-YYYY";
    DATE_FORMATS["M_D_YYYY"] = "M-D-YYYY";
    DATE_FORMATS["MM_YY"] = "MM yy";
    // Invalid
    DATE_FORMATS["MM_DD_YYYY"] = "MM-DD-YYYY";
    DATE_FORMATS["mm_dd_yy"] = "mm-dd-yy";
    DATE_FORMATS["HH_mm"] = "HH:mm";
    DATE_FORMATS["MM_DD_YYYY_HH_MM"] = "MM-DD-YYYY HH:MM";
    DATE_FORMATS["MM_DD_YYYY_HH_MM_AM_PM"] = "MM-DD-YYYY HH:MM PM";
    DATE_FORMATS["MM_DD_YYYY_HH_MM_AM_PM_TIMEZONE"] = "MM-DD-YYYY HH:MM PM TIMEZONE";
})(DATE_FORMATS || (DATE_FORMATS = {}));
export const DATE_TIME_FORMATTER = {
    [DATE_FORMATS.MM_DD_YYYY_HH_MM]: {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 12-hour clock
    },
    [DATE_FORMATS.MM_DD_YYYY_HH_MM_AM_PM]: {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // Use 12-hour clock
    },
    [DATE_FORMATS.M_D_YYYY_HH_MM_SS_AM_PM]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true, // Use 12-hour clock
    },
    [DATE_FORMATS.M_D_YYYY_H_MM_AM_PM]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // Use 12-hour clock
    },
    [DATE_FORMATS.M_D_YYYY_HH_MM]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // Use 12-hour clock
    },
    [DATE_FORMATS.M_D_YYYY]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    },
    [DATE_FORMATS.mm_dd_yy]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    },
    [DATE_FORMATS.MM_DD_YYYY]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    },
    [DATE_FORMATS.MM_DD_YYYY_HH_MM_AM_PM_TIMEZONE]: {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
        hour12: true, // Use 12-hour clock
    },
    [DATE_FORMATS.M_D_YYYY_H_MM_AM_PM_TIMEZONE]: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
        hour12: true, // Use 12-hour clock
    },
    [DATE_FORMATS.M_DD_YYYY]: undefined,
    [DATE_FORMATS.MM_YY]: undefined,
    [DATE_FORMATS.HH_mm]: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    },
};
export var NUMBER_FORMATTER_KEY;
(function (NUMBER_FORMATTER_KEY) {
    NUMBER_FORMATTER_KEY["CURRENCY_USD"] = "$X,XXX.XX";
})(NUMBER_FORMATTER_KEY || (NUMBER_FORMATTER_KEY = {}));
export var LOCALES_KEY;
(function (LOCALES_KEY) {
    LOCALES_KEY["EN_US"] = "en-US";
})(LOCALES_KEY || (LOCALES_KEY = {}));
export const NUMBER_FORMATTER_OPTIONS = {
    [NUMBER_FORMATTER_KEY.CURRENCY_USD]: {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
    },
};
export const INTERNET_CONNECTION_PROVIDER = 'QTS';
export const EmailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const MAX_DATE = '12-31-2090';
export const INT_MAX = 2147483647;
export const DISABLED_DAYS = [0, 6];
export const REPORTS_PAGE_LABELS = {
    reportsHeading: 'Reports',
    requests: 'Requests',
    iam: 'IAM',
    orders: 'Orders',
    connectivity_services: 'Connectivity Services',
    filters: 'Filters',
    downloadReport: 'Download Report',
    delete: 'Delete',
    cancel: 'Cancel',
    preset: 'Reports',
    custom: 'Custom Searches',
};
export const REPORTS_NAVIGATION = {
    reports: 'reports',
    preset: 'preset',
    custom: 'custom',
};
export const EMPLOYEE_COLUMN = [
    'companyName',
    'cpyId',
    'sfQuoteGpContractNumber',
];
export const QTS_DATACENTER_TIMEZONE = [
    'US/Eastern',
    'US/Central',
    'US/Pacific',
    'US/Mountain',
];
export const TOKEN_VALIDATOR_URL = '/portal/token/access.do';
export const TOKEN_REFRESHER_URL = '/portal/token/refresh.do';
